import { ServiceApiTypeEnum } from "./service"

export type CalendarApiItem = {
    id?: string
    appointmentId: string
    bookingId: string
    groupClassAvailabilityId?: string
    groupClassId?: string
    groupClassSettingId?: string
    date: string
    deletedAt?: Date
    duration: number
    endTime: string
    locationId?: string
    locationName: string
    locationSpaceId: string
    locationSpaceName: string
    locationTimezone: string
    maxCapacity: number
    price: number
    primaryColorHex: string
    serviceId: string
    staffId?: string
    staffName?: string
    staffImageUrl?: string
    imageUrl?: string
    serviceName: string
    slotsAvailable: number
    slotsTaken: number
    startTime: string
    attendees?: Record<string, unknown>[]
    user?: any
    order?: any
    serviceType: string
    groupClassName: string
    onlineMeetingUrl?: string
}
export type CalendarSlotItem = {
    id: string
    availability_id?: string
    appointment_id?: string
    booking_id?: string
    client_id?: string
    setting_id?: string
    staff_id?: string
    staff_name?: string
    staff_photo?: string
    staff_availability_id?: string
    slots: {
        available: number
        taken: number
        max: number
    }
    title: string
    duration?: number
    instructor_name?: string
    location_id?: string
    location_name?: string
    location_space_id?: string
    location_space_name?: string
    timezone?: string
    price?: number
    discount?: number
    coupon?: string
    membership?: string
    service_id: string
    service_name: string
    space_name: string
    end: Date
    start: Date
    startTime?: Date
    primary_hex?: string
    attendees?: Record<string, unknown>[]
    order?: Record<string, unknown>
    user?: Record<string, unknown>
    imageUrl?: string
    service_type: string
    group_class_name: string
    online_meeting_url?: string
}

export enum ViewMode {
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
}

export enum StartDay {
    SUNDAY = "SUNDAY",
    MONDAY = "MONDAY"
}

export type CalendarSettings = {
    start_day: StartDay
    start_day_id?: string
    show_30_min: boolean
    show_30_min_id?: string
}

export const CALENDAR_START_DAY = "calendar_start_day"
export const CALENDAR_SHOW_30_MINS = "calendar_show_30_mins"
export const ALLOW_OVERLAP = "allow.overlap"

export function mapCalendarSlotFromDTO(dto: CalendarApiItem): CalendarSlotItem {
    const start = new Date(
        [dto.date, dto.startTime].join('T')
    )
    const end = new Date(
        start.getTime() + dto.duration * 60000
    )
    return {
        id: dto.groupClassId || dto.bookingId,
        availability_id: dto.groupClassAvailabilityId,
        appointment_id: dto.appointmentId,
        booking_id: dto.bookingId,
        attendees: dto.attendees,
        slots: {
            available: dto.slotsAvailable,
            taken: dto.slotsTaken,
            max: dto.maxCapacity,
        },
        service_id: dto.serviceId,
        title: [dto.serviceName, dto.locationName].join(
            ' @ '
        ),
        service_name: dto.serviceName,
        location_name: dto.locationName,
        location_id: dto.locationId,
        price: dto.price,
        setting_id: dto.groupClassSettingId,
        space_name: dto.locationSpaceName,
        start,
        startTime: start,
        end,
        primary_hex: dto.primaryColorHex,
        staff_id: dto.staffId,
        staff_name: dto.staffName,
        location_space_id: dto.locationSpaceId,
        location_space_name: dto.locationSpaceName,
        staff_photo: dto.staffImageUrl,
        order: dto?.order,
        user: dto?.user,
        service_type: dto.serviceType || ServiceApiTypeEnum.APPOINTMENT,
        group_class_name: dto.groupClassName,
        online_meeting_url: dto.onlineMeetingUrl
    }
}